<script setup>
import { RouterLink, RouterView, useRoute } from "vue-router";
import { reactive, ref, watch } from "vue";
import NavBar from "./components/NavBar.vue";
import { useLogoStore } from "./stores/logostore";
import Fade from "./components/Transitions/Fade.vue";
import { usePhotoStore } from "@/stores/photostore";
import { use98Store } from "@/stores/98store";
import IconMenu from "@/components/icons/IconMenu.vue";
import FooterComp from "./components/FooterComp.vue";
import MenuComponent from "./components/MenuComponent.vue";
import Logo from "./LogoComponent.vue";
// import Fade from "./components/Transitions/Fade.vue";
const logo = useLogoStore();

const route = useRoute();
let watermark_src = ref("/Watermark v3 black.png");


const mobile_menu_open = ref(false);
</script>
<template>
	<Transition name="slide-right">
		<MenuComponent
			v-if="mobile_menu_open"
			class="d-lg-none"
			:class="{ 'modal-open': mobile_menu_open }"
			@close="mobile_menu_open = false"
		/>
	</Transition>
	<RouterLink
		id="logo"
		class="wiggle pill onload sticky-top d-lg-flex d-none"
		to="/"
	>
		<Fade>
			<!-- <img class="logo" :src="logo.current_logo" /> -->
			<Logo/>
		</Fade>
	</RouterLink>
	<div id="header-wrapper" class="d-grid d-lg-block">
		<Transition name="slide-left">
			<Logo class="d-lg-none" v-if="!mobile_menu_open" @click="mobile_menu_open = !mobile_menu_open"/>
		</Transition>
		<div id="header"></div>
	</div>
	<NavBar />

	<div class="container-fluid" id="mainView">
		<RouterView class="container-fluid clearfix" />

		<!-- <router-view v-slot="{ Component }">
		<Fade>
			<component :is="Component"/>
		</Fade>
	</router-view> -->
	</div>
</template>
